import "@app/App.css";
import { Popover } from '@comps/ui/popover';
import { Workspace } from '@dto/workspaces';
import { PopoverContent, PopoverTrigger } from '@radix-ui/react-popover';
import { applyBrightness, DEFAULT_COMPOZZ_COLOR, IsDarkColor } from '@utils/colors';
import { SELECTED_WORKSPACE_ID } from '@utils/constants';
import { CIcon } from "@utils/icons";
import { TW_WorkspaceSelectorDownIcon, TW_WorkspaceSelectorItem, TW_WorkspaceSelectorItemIcon, TW_WorkspaceSelectorItemIconContainer, TW_WorkspaceSelectorItemText, TW_WorkspaceSelectorPopoverContent, TW_WorkspaceSelectorTrigger } from "@utils/twClasses";
import { ArrowDown2 } from "iconsax-react";
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useModelStore } from "src/store";


function WorkspaceSelector() {

  const workspaces = useModelStore((state) => state.workspaces);
  const selectedWorkspace = useModelStore((state) => state.selectedWorkspace);
  const selectWorkspace = useModelStore((state) => state.selectWorkspace);
  const navigate = useNavigate();

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  if (!workspaces || !selectedWorkspace) {
    return null;
  }


  const handleWorkspaceSelect = (workspace: Workspace) => {
    if (workspace && workspace !== selectedWorkspace) {
      selectWorkspace(workspace);
      localStorage.setItem(SELECTED_WORKSPACE_ID, workspace._key);
      setIsPopoverOpen(false);
      navigate(`/workspaces/${workspace._key}/objects`);
    }
  }
  

  return (

    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger className={TW_WorkspaceSelectorTrigger}>
        <WorkspaceSelectorItem workspace={selectedWorkspace} />
      </PopoverTrigger>
      <PopoverContent className={TW_WorkspaceSelectorPopoverContent} onClick={(e) => e.stopPropagation()}>
          {workspaces.map((workspace) => (
            <div key={workspace._key} className={TW_WorkspaceSelectorItem} onClick={() => handleWorkspaceSelect(workspace)}>
              <WorkspaceSelectorItem workspace={workspace} />
            </div>
          ))}
      </PopoverContent>
    </Popover>
  );
};

function WorkspaceSelectorItem({workspace}: {workspace: Workspace}) {

  const [isHovered, setIsHovered] = useState(false);
  const wsColor = workspace.color ?? DEFAULT_COMPOZZ_COLOR;
  const wsDarkColor = applyBrightness(wsColor, -25);
  const isDarkColor = IsDarkColor(wsColor);
  return (
    <div className={TW_WorkspaceSelectorItem} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}
      style={
        {
          borderColor: wsDarkColor,
          backgroundColor: isHovered ? wsDarkColor : wsColor
        }
      }>
      <div className={TW_WorkspaceSelectorItemIconContainer} 
        style={
          {
            backgroundColor: wsDarkColor,
            borderColor: wsDarkColor,
          }
        }>
        <CIcon compozzIcon={workspace.icon!} color={(isDarkColor) ? 'white' : 'black'} className={TW_WorkspaceSelectorItemIcon} />
      </div>
      <p className={TW_WorkspaceSelectorItemText + (isDarkColor ? ' text-white' : '')}>{workspace.name}</p>
    </div>
  );
}

export default WorkspaceSelector;